import React from "react";

export const Logo = () => {
  return <h1> 🏝 Far Away</h1>;
};
